<template>
  <transition name="fade" mode="out-in">
    <div class="modal" v-if="isOpen">
      <div class="modal__overlay" @click="onClick()"></div>
      <div class="modal__body">
        <button type="button" @click="onClick()">
          <v-icon large color="yellow">mdi-close-box</v-icon>
        </button>
        <div class="youtube__wrapper">
          <youtube :video-id="modalContent.movieId" ref="youtube"></youtube>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      modalContent: {
        type: Object,
      },
      isOpen: {
        type: Boolean,
      },
    },
    methods: {
      onClick() {
        this.$emit("modal-close");
      },
    },
  };
</script>
